import { PdfViewerToolbarButton } from '../../PdfViewerToolbarButton'

import {
  PDF_VIEWER_TOOLBAR_THUMBNAILS_ICON_PROPS,
  QA_NAME_PDF_VIEWER_TOOLBAR_THUMBNAILS_BTN,
} from './PdfViewerToolbarThumbnailsTool.constants'

function PdfViewerToolbarThumbnailsTool({
  isThumbnailsOpen,
  onToggleThumbnails,
}) {
  return (
    <PdfViewerToolbarButton
      iconProps={PDF_VIEWER_TOOLBAR_THUMBNAILS_ICON_PROPS}
      isActive={isThumbnailsOpen}
      qaName={QA_NAME_PDF_VIEWER_TOOLBAR_THUMBNAILS_BTN}
      titleKey='PdfViewer.ThumbnailsBtnKey'
      onClick={onToggleThumbnails}
    />
  )
}

export default PdfViewerToolbarThumbnailsTool
